var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.54834 11.9996C2.07714 7.13121 6.62514 3.59961 11.9987 3.59961C17.3723 3.59961 21.9203 7.13121 23.4491 11.9996C21.9203 16.868 17.3723 20.3996 11.9987 20.3996C6.62514 20.3996 2.07714 16.868 0.54834 11.9996ZM16.7987 11.9996C16.7987 13.2726 16.293 14.4935 15.3929 15.3937C14.4927 16.2939 13.2718 16.7996 11.9987 16.7996C10.7257 16.7996 9.5048 16.2939 8.60463 15.3937C7.70445 14.4935 7.19874 13.2726 7.19874 11.9996C7.19874 10.7266 7.70445 9.50567 8.60463 8.6055C9.5048 7.70532 10.7257 7.19961 11.9987 7.19961C13.2718 7.19961 14.4927 7.70532 15.3929 8.6055C16.293 9.50567 16.7987 10.7266 16.7987 11.9996Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.3996C12.6364 14.3996 13.2469 14.1468 13.697 13.6967C14.147 13.2466 14.3999 12.6361 14.3999 11.9996C14.3999 11.3631 14.147 10.7526 13.697 10.3026C13.2469 9.85247 12.6364 9.59961 11.9999 9.59961C11.3634 9.59961 10.7529 9.85247 10.3028 10.3026C9.85276 10.7526 9.5999 11.3631 9.5999 11.9996C9.5999 12.6361 9.85276 13.2466 10.3028 13.6967C10.7529 14.1468 11.3634 14.3996 11.9999 14.3996Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.78f385628c8bdde0024422914a53aa79.svg";
export { ForwardRef as ReactComponent };